__turbopack_context__.v({
  "animate-carousel-in": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__animate-carousel-in",
  "card": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__card",
  "carousel": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__carousel",
  "carouselContainer": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__carouselContainer",
  "carouselSwapContainer": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__carouselSwapContainer",
  "fade-in": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__fade-in",
  "inner": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__inner",
  "isActive": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__isActive",
  "isReady": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__isReady",
  "isTransition": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__isTransition",
  "item": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__item",
  "root": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__root",
  "skeletonCard": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__skeletonCard",
  "skeletonImage": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__skeletonImage",
  "skeletonParagraph": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__skeletonParagraph",
  "slide": "PersonalizedRecipesCarousel-module-scss-module__IPFeGq__slide",
});
